import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js/features/string/repeat";
import "abortcontroller-polyfill";

import React from "react";
import { render } from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import "./index.css";
import "./App.less";

import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

import Bowser from "bowser";
/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
export const msalInstance = new PublicClientApplication(msalConfig);

//msal can hold more than one cached account (an entra directory switch leaves the
//old one behind), and getAllAccounts() has no defined order - prefer the configured
//tenant so we never acquire tokens as the user's old identity
const selectAccount = (accounts) => {
	const tenantId = process.env.REACT_APP_TENANT_ID;
	const inTenant = tenantId
		? accounts.filter((a) => a.tenantId === tenantId)
		: accounts;
	return (inTenant.length > 0 ? inTenant : accounts)[0];
};

const cachedAccounts = msalInstance.getAllAccounts();
if (cachedAccounts.length > 0)
	msalInstance.setActiveAccount(selectAccount(cachedAccounts));

//keep the active account current after an interactive or silent sign in
msalInstance.addEventCallback((event) => {
	if (
		(event.eventType === EventType.LOGIN_SUCCESS ||
			event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
			event.eventType === EventType.SSO_SILENT_SUCCESS) &&
		event.payload?.account
	) {
		msalInstance.setActiveAccount(event.payload.account);
	}
});

const browser = Bowser.getParser(window.navigator.userAgent);
const isValidBrowser = browser.satisfies({
	// also supports equality operator
	chrome: ">=49", // will match particular build only
	edge: ">=84",
	firefox: ">=78",
	safari: ">=9.3",
	opera: ">=76",
	"android browser": ">=4",
	samsung: ">=11",
	"internet explorer": ">=11",
});
window.localStorage.setItem("browser", JSON.stringify(browser));
window.localStorage.setItem("isValidBrowser", isValidBrowser);

render(
	process.env.REACT_APP_ENVIRONMENT === "AZURE" ? (
		<MsalProvider instance={msalInstance}>
			<App />
		</MsalProvider>
	) : (
		<App />
	),
	document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
